import { api } from '@/lib/api';

/** One (category × role × region) rule row from the backend. */
export interface AssignmentRuleRow {
  id: string;
  category_code: string;
  role: 'solver' | 'approver' | 'communicator' | 'owner';
  geo_band: string;
  assignee_user_id: string | null;
  special: 'ticket_creator' | 'none' | null;
}

export interface StoreRegionRow {
  store_code: string;
  geo_band: string;
}

export interface AssignmentMatrixConfig {
  rules: AssignmentRuleRow[];
  storeRegions: StoreRegionRow[];
}

export interface SaveMatrixPayload {
  rules?: Array<{
    category_code: string;
    role: string;
    geo_band: string;
    assignee_user_id: string | null;
    special: string | null;
  }>;
  storeRegions?: Array<{ store_code: string; geo_band: string }>;
}

export const assignmentMatrixApi = {
  /** Admin-only — full matrix + region config for the editor. */
  get: () => api.get<AssignmentMatrixConfig>('/assignment-matrix'),
  /** Admin-only — upsert rules + region mapping; invalidates the resolver cache. */
  save: (payload: SaveMatrixPayload) =>
    api.put<{ rulesSaved: number; regionsSaved: number }>('/assignment-matrix', payload)
};

export const ASSIGNMENT_REGIONS = ['AU/NZ', 'UK', 'IN/UAE/EU', 'US/CA'] as const;
export type AssignmentRegion = (typeof ASSIGNMENT_REGIONS)[number];

export const ASSIGNMENT_ROLES = ['solver', 'approver', 'communicator', 'owner'] as const;
export type AssignmentRoleName = (typeof ASSIGNMENT_ROLES)[number];
